import { Button } from "@/components/ui/button";
import { Loader2, Linkedin } from "lucide-react";
import { useState } from "react";
import { supabase } from "@/lib/supabase/client";
import { useToast } from "@/hooks/use-toast";

export function SocialAuth() {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handleLinkedInSignIn = async () => {
    try {
      setIsLoading(true);

      // Using LinkedIn OIDC as recommended by Supabase
      const provider = 'linkedin_oidc';

      const { error } = await supabase.auth.signInWithOAuth({
        provider,
        options: {
          // Ensure the redirect URL exactly matches your Supabase & LinkedIn configuration.
          redirectTo: `${window.location.origin}/auth/callback`,
        },
      });

      if (error) {
        throw error;
      }
    } catch (error) {
      toast({
        title: 'LinkedIn Sign-In Error',
        description:
          error instanceof Error
            ? error.message
            : 'Failed to sign in with LinkedIn',
        variant: 'destructive',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <span className="w-full border-t" />
        </div>
        <div className="relative flex justify-center text-xs uppercase">
          <span className="bg-background px-2 text-muted-foreground">
            Or continue with
          </span>
        </div>
      </div>

      <Button
        variant="outline"
        type="button"
        className="w-full"
        onClick={handleLinkedInSignIn}
        disabled={isLoading}
      >
        {isLoading ? (
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
        ) : (
          <Linkedin className="mr-2 h-4 w-4" />
        )}
        Sign in with LinkedIn
      </Button>
    </div>
  );
}
